"use client";

import { useTrackJobViewed } from "@/hooks/use-track-job-viewed";

interface JobViewTrackerProps {
  jobId: string;
  schoolNcesId: string;
  districtId: string;
  state: string;
}

/**
 * Client component wrapper that tracks job views for Server Components.
 * Renders nothing - only used for bridging the analytics side effect across boundaries.
 * For Client Components, use `useTrackJobViewed` directly instead.
 */
export default function JobViewTracker({
  jobId,
  schoolNcesId,
  districtId,
  state,
}: JobViewTrackerProps) {
  useTrackJobViewed({
    jobId,
    schoolNcesId,
    districtId,
    state,
  });

  return null;
}
